function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProduct(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 500 500",
    style: {
      enableBackground: "new 0 0 500 500"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "BACKGROUND"
  }, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#FFFFFF"
    },
    width: 500,
    height: 500
  })), /*#__PURE__*/React.createElement("g", {
    id: "OBJECTS"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#007DFF"
    },
    points: "177.234,323.998 106.333,253.094 125.169,234.258 175.074,284.162 289.301,142.002  310.066,158.681  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#007DFF"
    },
    points: "260.821,323.998 226.284,289.458 243.067,268.566 258.664,284.162 372.903,142.002  393.667,158.681  "
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_1_",
    cx: 496.6647,
    cy: 738.525,
    r: 37.2283,
    gradientTransform: "matrix(-3.2074 0 0 -0.129 1837.0024 495.0587)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1429,
    style: {
      stopColor: "#000000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#DAE5DF",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.2,
      fill: "url(#SVGID_1_)"
    },
    d: "M76,399.767c0-3.794,75.216-6.869,168-6.869c92.784,0,168,3.075,168,6.869 c0,3.793-75.216,6.869-168,6.869C151.216,406.635,76,403.56,76,399.767z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "DESIGNED_BY_FREEPIK"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_29_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_48_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_56_",
    style: {
      fill: "#1D262D"
    },
    d: "M260.104,465.724c-0.432,0.443-0.803,0.931-1.108,1.453l-0.465-0.241 c-0.067-0.298-0.349-0.503-0.659-0.466c-0.331,0.039-0.568,0.339-0.529,0.67c0.039,0.331,0.339,0.568,0.67,0.529 c0.066-0.008,0.127-0.026,0.184-0.052l0.451,0.234c-0.251,0.554-0.433,1.139-0.539,1.744l0.746,0.132 c0.23-1.306,0.85-2.507,1.792-3.473L260.104,465.724z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_55_",
    style: {
      fill: "#1D262D"
    },
    d: "M265.592,463.422c-0.171,0-0.341,0.006-0.51,0.017l-0.074-0.626 c0.188-0.149,0.296-0.389,0.266-0.645c-0.046-0.393-0.402-0.674-0.795-0.628c-0.393,0.046-0.674,0.402-0.628,0.795 c0.03,0.254,0.189,0.461,0.404,0.564l0.074,0.624c-0.714,0.116-1.403,0.332-2.06,0.646l0.327,0.684 c0.934-0.447,1.942-0.673,2.995-0.673c0.496,0,0.993,0.053,1.475,0.158l0.161-0.741 C266.692,463.481,266.142,463.422,265.592,463.422z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_54_",
    style: {
      fill: "#1D262D"
    },
    d: "M272.194,465.969c0.331-0.04,0.566-0.341,0.526-0.672 c-0.04-0.331-0.341-0.566-0.672-0.526c-0.309,0.038-0.535,0.304-0.53,0.609l-0.416,0.363c-0.418-0.43-0.889-0.813-1.408-1.139 l-0.404,0.641c1.134,0.715,2.021,1.726,2.563,2.925l0.69-0.313c-0.251-0.554-0.568-1.072-0.942-1.545l0.402-0.351 C272.065,465.974,272.129,465.977,272.194,465.969z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_53_",
    style: {
      fill: "#1D262D"
    },
    d: "M265.044,473.63c-0.386,0.023-0.775,0.035-1.157,0.035 c-0.88,0-1.733-0.061-2.478-0.179c-0.39-0.062-0.846-0.155-1.27-0.292c1.046,1.861,3.069,3.125,5.388,3.125 c2.855,0,5.262-1.916,5.95-4.504c-0.682,0.449-1.505,0.825-2.459,1.123C267.839,473.306,266.463,473.545,265.044,473.63z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_49_",
    style: {
      fill: "#1D262D"
    },
    d: "M265.592,464.938c-3.352,0-6.08,2.666-6.08,5.944 c0,0.426,0.046,0.849,0.137,1.261c0.673,0.483,2.706,0.89,5.348,0.731c2.879-0.173,5.297-0.957,6.672-2.159 c-0.006-0.195-0.021-0.39-0.045-0.582C271.244,467.172,268.65,464.938,265.592,464.938z M263.432,471.453 c-1.02,0-1.85-0.83-1.85-1.85c0-1.02,0.83-1.85,1.85-1.85c1.02,0,1.85,0.83,1.85,1.85 C265.282,470.623,264.452,471.453,263.432,471.453z M268.17,470.545c-0.75,0-1.36-0.61-1.36-1.36c0-0.75,0.61-1.36,1.36-1.36 c0.75,0,1.361,0.61,1.361,1.36C269.53,469.935,268.92,470.545,268.17,470.545z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_46_",
    style: {
      fill: "#1D262D"
    },
    d: "M281.595,466.805c-0.295-0.116-0.805-0.309-1.382-0.237 c-0.551,0.069-0.844,0.34-0.844,1.007v0.866h2.228v1.717h-2.228v5.455h-1.932v-5.455h-1.34v-1.717h1.34v-0.888 c0-1.68,0.896-2.783,2.568-2.783c0.643,0,1.157,0.122,1.59,0.308L281.595,466.805z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_44_",
    style: {
      fill: "#1D262D"
    },
    d: "M286.298,470.137c-0.177-0.03-0.358-0.046-0.526-0.046 c-0.895,0-1.51,0.548-1.51,1.613v3.908h-1.932v-7.172h1.873v0.785c0.451-0.673,1.14-0.977,2.021-0.977 c0.414,0,0.848,0.128,1.094,0.337L286.298,470.137z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_41_",
    style: {
      fill: "#1D262D"
    },
    d: "M293.965,472.015c0,0.222-0.015,0.489-0.037,0.651h-5.085 c0.207,1.036,0.933,1.488,1.843,1.488c0.622,0,1.295-0.252,1.813-0.688l1.133,1.243c-0.814,0.748-1.85,1.088-3.057,1.088 c-2.198,0-3.723-1.495-3.723-3.752c0-2.258,1.48-3.797,3.627-3.797C292.544,468.248,293.958,469.78,293.965,472.015z  M288.851,471.349h3.175c-0.177-0.918-0.733-1.436-1.562-1.436C289.554,469.913,289.021,470.461,288.851,471.349z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_38_",
    style: {
      fill: "#1D262D"
    },
    d: "M301.618,472.015c0,0.222-0.015,0.489-0.037,0.651h-5.085 c0.207,1.036,0.932,1.488,1.843,1.488c0.622,0,1.295-0.252,1.814-0.688l1.132,1.243c-0.814,0.748-1.85,1.088-3.057,1.088 c-2.198,0-3.723-1.495-3.723-3.752c0-2.258,1.48-3.797,3.627-3.797C300.197,468.248,301.611,469.78,301.618,472.015z  M296.504,471.349h3.175c-0.178-0.918-0.733-1.436-1.562-1.436C297.207,469.913,296.674,470.461,296.504,471.349z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_35_",
    style: {
      fill: "#1D262D"
    },
    d: "M309.964,472.023c0,2.154-1.495,3.775-3.471,3.775 c-0.962,0-1.643-0.377-2.109-0.933v3.708h-1.924V468.44h1.887v0.792c0.466-0.585,1.155-0.984,2.139-0.984 C308.469,468.248,309.964,469.869,309.964,472.023z M304.287,472.023c0,1.132,0.747,1.976,1.843,1.976 c1.14,0,1.85-0.881,1.85-1.976c0-1.095-0.711-1.976-1.85-1.976C305.035,470.047,304.287,470.89,304.287,472.023z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_32_",
    style: {
      fill: "#1D262D"
    },
    d: "M313.067,466.094c0,0.696-0.54,1.229-1.236,1.229 c-0.696,0-1.229-0.533-1.229-1.229c0-0.696,0.533-1.243,1.229-1.243C312.527,464.851,313.067,465.398,313.067,466.094z  M312.809,475.612h-1.932v-7.172h1.932V475.612z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_30_",
    style: {
      fill: "#1D262D"
    },
    d: "M316.032,470.994l2.702-2.554h2.368l-3.479,3.375l3.501,3.797h-2.376l-2.716-2.901 v2.901H314.1v-10.658h1.932V470.994z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1D262D"
    },
    d: "M184.412,475.547v-1.055c-0.527,0.718-1.391,1.23-2.387,1.23c-1.846,0-3.149-1.406-3.149-3.706 c0-2.256,1.289-3.721,3.149-3.721c0.952,0,1.816,0.469,2.387,1.245v-3.765h1.099v9.77H184.412z M184.412,473.629v-3.208 c-0.395-0.615-1.245-1.143-2.124-1.143c-1.421,0-2.27,1.172-2.27,2.739c0,1.567,0.85,2.724,2.27,2.724 C183.168,474.742,184.017,474.244,184.412,473.629z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1D262D"
    },
    d: "M186.932,472.003c0-2.051,1.465-3.706,3.486-3.706c2.139,0,3.398,1.67,3.398,3.794v0.279h-5.727 c0.088,1.333,1.025,2.446,2.549,2.446c0.805,0,1.626-0.322,2.182-0.893l0.527,0.718c-0.703,0.703-1.655,1.084-2.812,1.084 C188.44,475.723,186.932,474.215,186.932,472.003z M190.403,469.205c-1.509,0-2.256,1.274-2.314,2.358h4.643 C192.718,470.509,192.015,469.205,190.403,469.205z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1D262D"
    },
    d: "M194.607,474.61l0.571-0.791c0.469,0.542,1.362,1.011,2.329,1.011c1.084,0,1.67-0.513,1.67-1.216 c0-1.714-4.38-0.659-4.38-3.281c0-1.098,0.952-2.036,2.636-2.036c1.201,0,2.051,0.454,2.622,1.025l-0.513,0.762 c-0.424-0.513-1.201-0.894-2.109-0.894c-0.967,0-1.567,0.483-1.567,1.113c0,1.553,4.38,0.527,4.38,3.281 c0,1.187-0.952,2.139-2.783,2.139C196.306,475.723,195.325,475.372,194.607,474.61z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1D262D"
    },
    d: "M201.477,466.729c0-0.41,0.337-0.747,0.732-0.747c0.41,0,0.747,0.337,0.747,0.747 c0,0.41-0.337,0.732-0.747,0.732C201.814,467.462,201.477,467.14,201.477,466.729z M201.667,475.547v-7.075h1.099v7.075H201.667z "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1D262D"
    },
    d: "M204.582,477.364l0.556-0.82c0.586,0.703,1.289,0.967,2.3,0.967c1.172,0,2.27-0.571,2.27-2.124 v-1.011c-0.513,0.718-1.377,1.26-2.373,1.26c-1.845,0-3.149-1.377-3.149-3.662c0-2.27,1.289-3.676,3.149-3.676 c0.952,0,1.802,0.469,2.373,1.245v-1.069h1.098v6.87c0,2.344-1.641,3.076-3.369,3.076 C206.237,478.418,205.417,478.184,204.582,477.364z M209.709,473.512v-3.091c-0.381-0.615-1.23-1.143-2.109-1.143 c-1.421,0-2.27,1.128-2.27,2.695c0,1.553,0.849,2.695,2.27,2.695C208.478,474.669,209.328,474.127,209.709,473.512z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1D262D"
    },
    d: "M217.413,475.547v-4.629c0-1.245-0.63-1.641-1.582-1.641c-0.865,0-1.685,0.527-2.095,1.099v5.17 h-1.099v-7.075h1.099v1.025c0.498-0.586,1.465-1.201,2.519-1.201c1.48,0,2.256,0.747,2.256,2.285v4.966H217.413z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1D262D"
    },
    d: "M219.932,472.003c0-2.051,1.465-3.706,3.486-3.706c2.139,0,3.398,1.67,3.398,3.794v0.279h-5.727 c0.088,1.333,1.025,2.446,2.549,2.446c0.806,0,1.626-0.322,2.183-0.893l0.527,0.718c-0.703,0.703-1.655,1.084-2.812,1.084 C221.441,475.723,219.932,474.215,219.932,472.003z M223.404,469.205c-1.509,0-2.256,1.274-2.314,2.358h4.643 C225.718,470.509,225.015,469.205,223.404,469.205z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1D262D"
    },
    d: "M233.35,475.547v-1.055c-0.527,0.718-1.392,1.23-2.388,1.23c-1.846,0-3.149-1.406-3.149-3.706 c0-2.256,1.289-3.721,3.149-3.721c0.952,0,1.817,0.469,2.388,1.245v-3.765h1.098v9.77H233.35z M233.35,473.629v-3.208 c-0.396-0.615-1.245-1.143-2.124-1.143c-1.421,0-2.27,1.172-2.27,2.739c0,1.567,0.849,2.724,2.27,2.724 C232.105,474.742,232.954,474.244,233.35,473.629z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1D262D"
    },
    d: "M239.692,475.547v-9.77h1.098v3.765c0.572-0.776,1.421-1.245,2.388-1.245 c1.845,0,3.149,1.465,3.149,3.721c0,2.299-1.304,3.706-3.149,3.706c-0.996,0-1.86-0.513-2.388-1.23v1.055H239.692z  M242.9,474.742c1.436,0,2.285-1.157,2.285-2.724c0-1.567-0.85-2.739-2.285-2.739c-0.864,0-1.728,0.527-2.109,1.143v3.208 C241.171,474.244,242.036,474.742,242.9,474.742z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1D262D"
    },
    d: "M247.528,477.32c0.161,0.073,0.425,0.117,0.601,0.117c0.483,0,0.805-0.161,1.055-0.747 l0.469-1.069l-2.959-7.148h1.187l2.358,5.801l2.344-5.801h1.201l-3.545,8.51c-0.425,1.025-1.143,1.421-2.08,1.435 c-0.234,0-0.601-0.044-0.806-0.103L247.528,477.32z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProduct);
export default __webpack_public_path__ + "static/media/product.663af318648e3456fd50771ad8af2e70.svg";
export { ForwardRef as ReactComponent };